// Messages from an embedded result to the page that embeds it (the Chrome extension popup). They carry
// nothing beyond the content height, so they go to any parent origin; the parent checks where they come from.
export const EMBED_MESSAGES = Object.freeze({
  resize: 'exatom-score:resize',
  rescore: 'exatom-score:rescore'
})
